import loadable from '@loadable/component';
import { Heading } from './styled';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';

const PriceVolatilityMarketGraph = loadable(
  () => import('./components/PriceVolatilityMarketGraph'),
  { ssr: false }
);

interface Props {
  companyName: string;
  country: string;
  industry: string;
  tickerSymbol: string;
  companyValue?: null | number;
  industryValue?: null | number;
  skipDefer?: boolean;
}

const PriceVolatilityMarket = ({
  companyName,
  country,
  industry,
  tickerSymbol,
  companyValue,
  industryValue,
  skipDefer,
}: Props) => (
  <>
    <Heading>Long-Term Price Volatility Vs. Market</Heading>
    <p>
      How volatile is {companyName}'s share price compared to the market and
      industry in the last 5 years?
    </p>
    <DeferRenderUntilIntersecting skipDefer={skipDefer}>
      {() => (
        <PriceVolatilityMarketGraph
          country={country}
          industry={industry}
          tickerSymbol={tickerSymbol}
          companyValue={companyValue || 0}
          industryValue={industryValue || 0}
        />
      )}
    </DeferRenderUntilIntersecting>
  </>
);

export default PriceVolatilityMarket;
